"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Portal = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Portal"));
var _context = require("../../../services/currency/context");
var _context2 = require("../../../services/intl/context");
var _RegionalSettings = _interopRequireDefault(require("../../RegionalSettings"));
var _Currency = require("../../../records/Currency");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RegionalSettingsButton = _ref => {
  let {
    render,
    modalId,
    brandLanguage,
    simple = false,
    triggerRef
  } = _ref;
  const [showModal, setShowModal] = React.useState(false);
  const {
    currency: {
      code,
      format
    }
  } = (0, _context.useCurrency)();
  const currencySymbol = (0, _Currency.getSymbol)(format.format);
  const {
    language: {
      displayName
    }
  } = (0, _context2.useIntl)();
  const toggle = () => setShowModal(show => !show);
  const text = simple ? code : `${displayName} - ${code} ${currencySymbol}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [render({
      text,
      openModal: toggle
    }), showModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.default, {
      renderInto: modalId,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RegionalSettings.default, {
        onClose: toggle,
        brandLanguage: brandLanguage,
        triggerRef: triggerRef
      })
    })]
  });
};
var _default = exports.default = RegionalSettingsButton;